import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ParentsInformationRequest } from '../../models/parents-information/parentsInformationRequest';
import { ParentsInformationResponse } from '../../models/parents-information/parentsInformationResponse';
import { GenericService } from '../generic.service';
import { apiResponse } from '../../models/apiResponse';

@Injectable({
  providedIn: 'root'
})
export class ParentsInformationService {
  private readonly genericService = inject(GenericService);
  private readonly endpoint = 'parentsinformation';

  /**
   * Create new parents information
   * @param request - Parents information data
   * @returns Observable of created parents information
   */
  createParentsInformation(request: ParentsInformationRequest): Observable<ParentsInformationResponse> {
    return this.genericService.post<ParentsInformationResponse>(this.endpoint, request);
  }

  /**
   * Get parents information by ID
   * @param id - Parents information ID
   * @returns Observable of parents information
   */
  getParentsInformationById(id: number): Observable<ParentsInformationResponse> {
    return this.genericService.get<ParentsInformationResponse>(`${this.endpoint}/${id}`);
  }

  /**
   * Get parents information by student ID
   * @param studentId - Student ID
   * @returns Observable of parents information array
   */
  getParentsInformationByStudentId(studentId: string): Observable<apiResponse<ParentsInformationResponse[]>> {
    return this.genericService.get<apiResponse<ParentsInformationResponse[]>>(`${this.endpoint}/student/${studentId}`);
  }

  /**
   * Update parents information
   * @param id - Parents information ID
   * @param request - Updated parents information data
   * @returns Observable of updated parents information
   */
  updateParentsInformation(id: number, request: ParentsInformationRequest): Observable<ParentsInformationResponse> {
    return this.genericService.put<ParentsInformationResponse>(`${this.endpoint}/${id}`, request);
  }
}
